<!--
 * @Author: Ximen
 * @Date: 2021-03-23 19:40:08
 * @LastEditors: Ximen
 * @LastEditTime: 2021-04-07 14:47:54
-->
<template>
  <a-card class="box">
    <div style="padding:26px 0">
      <p class="title">他们都在用</p>
      <a @click="openCooperation" class="more">查看更多案例 ></a>
      <img src="@/assets/company-b.jpg" class="img" alt="">
    </div>
  </a-card>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'Cooperation',
  components: {
  },
  methods: {
    openCooperation() {
      window.open('https://cloud.seatent.com/_customers.html');
    },
  },
});
</script>
<style lang="stylus" scoped>
    .box
      border-radius 20px
      width 382px
      .title
        font-size 24px
        color #323233
        margin-bottom 13px
      .more
        font-size 14px
        color #3281DD
        margin-bottom 25px
      .img
        width 90%
</style>
